import { get } from 'lodash';

const styles = ({ color }) => ({
  parentContainer: {
    margin: 'auto',
  },
  content: {
    border: `1px solid ${color.borderColor}`,
    width: 450,
    padding: 50,
    alignItems: 'center',
    backgroundColor: get(color, 'uiBackground'),
  },
  container: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  pageTitle: {
    textAlign: 'center',
  },
  logoImage: {
    height: 100,
    display: 'flex',
    textAlign: 'center',
  },
  warningAndSubTitle: {
    display: 'flex',
    alignItems: 'center',
  },
  warningIcon: {
    marginTop: 12,
    marginRight: 8,
  },
  actionButton: {
    marginTop: 20,
    width: '100%',
  },
});

export default styles;
